const content = `%c==================
App Version ${APP_VERSION}
==================
%cIf someone told you to copy-paste something here it is a scam and will give them access to your money!`

export default () => {
  /* eslint-disable-next-line no-console */
  console.log(content, 'font-size: 14px;', 'font-size: 12px;')
}
